import { AbstractGetAllStore } from "../common/AbstractStores";
import { Dispatcher } from "../common/dispatcher";
import Actions from "./caldaieActions"

class __MarcheCaldaieGlobalStore extends AbstractGetAllStore<string>{
    constructor() {
        super(x => x);
        Dispatcher
            .onfunction(Actions.getMarcheCaldaieGlobal, result => this.setAll(result!))
    }

    public useAll() {
        return this.useAllWithAction(() => Actions.getMarcheCaldaieGlobal())
    }
}

export default new __MarcheCaldaieGlobalStore();